import { getScript } from '@/lib/utils';

const state = {
  facebookAppId: null,
  enableEmbeddedFacebook: false,
  loggedIn: false
};

const mutations = {
  SET_FACEBOOK_APP_ID(state, facebookAppId) {
    state.facebookAppId = facebookAppId;
  },
  SET_ENABLE_EMBEDDED_FACEBOOK(state, enableEmbeddedFacebook) {
    state.enableEmbeddedFacebook = enableEmbeddedFacebook;
  },
  SET_FACEBOOK_LOGGED_IN(state, loggedIn) {
    state.loggedIn = loggedIn;
  }
};

const actions = {
  fetchFacebooks({ rootState, commit }) {
    return rootState.api.fetchFacebooks().then(({ data }) => {
      commit('SET_FACEBOOK_APP_ID', data.facebook_app_id);
      commit('SET_ENABLE_EMBEDDED_FACEBOOK', data.enable_embedded_facebook);
    });
  },
  initFacebook({ commit, state }) {
    const FBAsyncInit = () => {
      window.FB.init({
        appId: state.facebookAppId,
        xfbml: true,
        cookie: true,
        version: 'v20.0'
      });

      window.FB.getLoginStatus(response => {
        commit('SET_FACEBOOK_LOGGED_IN', response.status === 'connected');
      });
      window.FB.Event.subscribe('auth.statusChange', response =>
        commit('SET_FACEBOOK_LOGGED_IN', response.status === 'connected')
      );
    };

    if (window.FB) {
      FBAsyncInit();
    } else {
      getScript('//connect.facebook.net/ko_KR/sdk.js', FBAsyncInit);
    }
  }
};

export default { namespaced: true, state, mutations, actions };
